import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function AsciiPage() {
    const navigate = useNavigate();
    const [isFading, setIsFading] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            navigate("/landing");
        }, 5000);

        const fadeTimeout = setTimeout(() => {
            setIsFading(true);
        }, 4500);

        const runAscii = async () => {
            const { run } = await import("./landingPageAnimation/run.js");
            const prog0 = await import("./landingPageAnimation/ExitFlame");

            const pre = document.querySelector("pre");
            const settings = {
                fps: 60,
                element: pre,
            };

            try {
                await run(prog0, settings);
            } catch (e) {
                console.warn(e.message);
                console.log(e.error);
            }
        };

        runAscii();

        return () => {
            clearTimeout(timeout);
            clearTimeout(fadeTimeout);
        };
    }, [navigate]);

    return (
        <div
            style={{
                width: "100vw",
                height: "100vh",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgb(250, 250, 250)",
                position: "relative",
            }}
        >
      <pre
          style={{
              margin: 0,
              padding: 0,
              width: "100%",
              height: "100%",
              fontSize: "1em",
              lineHeight: "1.2",
              fontFamily: "'Simple Console', monospace",
              backgroundColor: "black",
              color: "white",
          }}
      ></pre>
      {/* White overlay that fades in to soften the transition to the white app */}
      <div
          style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "white",
              opacity: isFading ? 1 : 0,
              transition: "opacity 600ms ease",
              pointerEvents: "none",
          }}
      />
        </div>
    );
}

export default AsciiPage;
